import { useEffect, useState } from 'react';

import {
  Accessibility,
  AccountBoxOutlined,
  Add,
  AddBoxRounded,
  AddCircle,
  AddRounded,
  ArrowBackRounded,
  CalendarTodayRounded,
  CardGiftcardRounded,
  Clear,
  Close,
  ContentCopyOutlined,
  Delete,
  Description,
  DragIndicator,
  EventNoteRounded,
  ExpandLess,
  ExpandMore,
  FilterAlt,
  HelpOutline,
  Home,
  HomeOutlined,
  InfoOutlined,
  InsertPhotoOutlined,
  Inventory,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
  KeyboardReturn,
  LocalShippingOutlined,
  LocalShippingRounded,
  Logout,
  MailOutline,
  MenuBookRounded,
  Mode,
  ModeEdit,
  MoreVert,
  PaidRounded,
  PaymentOutlined,
  PaymentsRounded,
  PeopleAlt,
  PeopleAltRounded,
  PercentRounded,
  Person,
  PointOfSaleRounded,
  PrecisionManufacturingRounded,
  PrintRounded,
  Search,
  Settings,
  ShoppingBag,
  StarRate,
  SvgIconComponent,
  SyncRounded,
  TextSnippetOutlined,
  TuneOutlined,
  Undo,
  Usb,
  Visibility,
  VisibilityOff,
  VisibilityOutlined,
} from '@mui/icons-material';
import { SxProps } from '@mui/system';

const iconsMap = {
  PaymentsRounded,
  PaidRounded,
  AddRounded,
  AccountBoxOutlined,
  AddCircle,
  Add,
  CalendarTodayRounded,
  Clear,
  Close,
  ContentCopyOutlined,
  Delete,
  Description,
  DragIndicator,
  EventNoteRounded,
  ExpandLess,
  ExpandMore,
  FilterAlt,
  HelpOutline,
  Home,
  HomeOutlined,
  InfoOutlined,
  InsertPhotoOutlined,
  Inventory,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
  KeyboardReturn,
  LocalShippingOutlined,
  LocalShippingRounded,
  Logout,
  MailOutline,
  MenuBookRounded,
  ModeEdit,
  Mode,
  MoreVert,
  PaymentOutlined,
  PeopleAlt,
  PeopleAltRounded,
  Person,
  PointOfSaleRounded,
  PrecisionManufacturingRounded,
  Search,
  Settings,
  ShoppingBag,
  SyncRounded,
  TextSnippetOutlined,
  TuneOutlined,
  Undo,
  Usb,
  Visibility,
  VisibilityOff,
  VisibilityOutlined,
  ArrowBackRounded,
  PercentRounded,
  AddBoxRounded,
  CardGiftcardRounded,
  PrintRounded,
  StarRate,
  Accessibility,
};

const getIcon = (icon: string): SvgIconComponent | null => {
  const IconComponent = iconsMap[icon as keyof typeof iconsMap];

  if (!IconComponent) {
    console.error(`Icon "${icon}" not found.`);
    return null;
  }

  return IconComponent;
};

type IconDisplayProps = {
  iconName: string;
  sx?: SxProps;
};

const IconDisplay = ({ iconName, sx }: IconDisplayProps) => {
  const [Icon, setIcon] = useState<SvgIconComponent | null>(null);

  useEffect(() => {
    const fetchIcon = () => {
      const IconComponent = getIcon(iconName);
      setIcon(IconComponent);
    };

    fetchIcon();
  }, [iconName]);

  return Icon ? (
    <Icon
      sx={{
        width: 35,
        height: 35,
        ...sx,
      }}
    />
  ) : null;
};

export default IconDisplay;
